var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_4842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19H13.2676C13.6134 19.5978 14.2597 20 15 20C16.1046 20 17 19.1046 17 18C17 16.8954 16.1046 16 15 16C14.2597 16 13.6134 16.4022 13.2676 17H2C1.44772 17 1 17.4477 1 18C1 18.5523 1.44772 19 2 19ZM19 18C19 17.4477 19.4477 17 20 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H20C19.4477 19 19 18.5523 19 18ZM2 5C1.44772 5 1 5.44772 1 6C1 6.55228 1.44772 7 2 7H9.26756C9.61337 7.5978 10.2597 8 11 8C12.1046 8 13 7.10457 13 6C13 4.89543 12.1046 4 11 4C10.2597 4 9.61337 4.4022 9.26756 5H2ZM4.26756 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H4.26756C4.61337 10.4022 5.25972 10 6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C5.25972 14 4.61337 13.5978 4.26756 13ZM16 5C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7H22C22.5523 7 23 6.55228 23 6C23 5.44772 22.5523 5 22 5H16ZM10 12C10 11.4477 10.4477 11 11 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H11C10.4477 13 10 12.5523 10 12Z",
    fill: "#14181A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_4842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/Filters.03e421065ec4639bb6ad61e1a28ea04c.svg";
export { ForwardRef as ReactComponent };